import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/smiling-woman-out-for-a-hike.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='variable-universal-life-insurance-financial-planning'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={<>Make a plan for <WidowBlock>tomorrow today.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            When you work with Northwestern Mutual, we listen to the goals you have and design a financial plan tailored specifically to your life. Variable universal life insurance is a flexible tool that could be an important part of your plan, giving you lifelong protection while helping you meet more of your financial goals. Find out more about how we plan.
          </Typography>
          <Link
            id='variable-universal-life-insurance-financial-planning-section-cta'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='Woman at the beach'
      imageSrcDefault={financialPlanningImageWebp}
    />
  );
};
